export enum VideoPinParticipant {
    Remote = 'remote',
    Local = 'local'
}